import React from "react";
import { motion } from "framer-motion";
import { INGREDIENTS } from "@/constants/testIds";

const ease = [0.22, 1, 0.36, 1];

const MILKY_BG = "/generated/bottle_mist.png";

const ingredients = [
  { name: "Rice milk", note: "Catifelare de la prima pulverizare." },
  { name: "Panthenol", note: "Calm și confort de durată." },
  { name: "Betaine", note: "Echilibru fără greutate." },
  { name: "Acid hialuronic", note: "Hidratare care persistă." },
  { name: "Ceramide", note: "Protecție pentru bariera pielii." },
  { name: "Parfum discret", note: "Un miros care rămâne aproape de piele." },
];

export default function Ingredients() {
  return (
    <section
      id="ingredients"
      data-testid={INGREDIENTS.section}
      className="relative py-28 md:py-44 overflow-hidden"
    >
      {/* milky background */}
      <div className="absolute inset-0 -z-10">
        <div className="absolute inset-0 bg-gradient-to-br from-[#F4F0EA] via-[#FDFBF7] to-[#EDE5DA]" />
        <img
          src={MILKY_BG}
          alt=""
          aria-hidden="true"
          className="absolute -right-20 top-1/2 -translate-y-1/2 h-[120%] w-auto object-contain opacity-[0.18] mix-blend-multiply hidden md:block"
        />
      </div>

      <div className="mx-auto max-w-[1400px] px-6 md:px-12 lg:px-16">
        <div className="grid grid-cols-12 gap-y-12 md:gap-x-16">
          <motion.div
            initial={{ opacity: 0, y: 24 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-80px" }}
            transition={{ duration: 1, ease }}
            className="col-span-12 md:col-span-5"
          >
            <p className="overline mb-12">— Formulă</p>
            <h2
              data-testid={INGREDIENTS.title}
              className="font-display text-3xl sm:text-4xl md:text-[3rem] leading-[1.15] text-[#2C2826] tracking-[-0.01em]"
            >
              Tot confortul unei creme.
              <br />
              <span className="accent-soft">În forma unui mist.</span>
            </h2>
            <p className="mt-6 text-[15px] leading-[1.85] text-[#5C5652] font-light max-w-md">
              Fiecare ingredient a fost ales pentru ceea ce simți pe piele, nu
              pentru ceea ce citești pe etichetă.
            </p>
          </motion.div>

          <motion.ul
            data-testid={INGREDIENTS.list}
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true, margin: "-80px" }}
            variants={{
              hidden: {},
              visible: { transition: { staggerChildren: 0.08 } },
            }}
            className="col-span-12 md:col-span-7 md:col-start-6 backdrop-blur-md bg-[#FDFBF7]/65 border border-[#E5DCD3]/70 divide-y divide-[#E5DCD3]/70"
          >
            {ingredients.map((it, i) => (
              <motion.li
                key={it.name}
                variants={{
                  hidden: { opacity: 0, y: 16 },
                  visible: { opacity: 1, y: 0 },
                }}
                transition={{ duration: 0.7, ease }}
                className="group flex items-baseline gap-6 md:gap-10 px-6 md:px-10 py-6 md:py-7 hover:bg-[#FDFBF7]/85 transition-colors duration-500"
              >
                <span className="overline text-[#8A7F77] w-8 shrink-0">
                  {String(i + 1).padStart(2, "0")}
                </span>
                <div className="flex-1 flex flex-col md:flex-row md:items-baseline gap-1 md:gap-6">
                  <h3 className="font-serif-classic text-xl md:text-2xl text-[#2C2826] tracking-[-0.005em]">
                    {it.name}
                  </h3>
                  <p className="text-[14px] text-[#5C5652] font-light leading-relaxed md:ml-auto md:text-right md:max-w-[18rem]">
                    {it.note}
                  </p>
                </div>
              </motion.li>
            ))}
          </motion.ul>
        </div>
      </div>
    </section>
  );
}
